import {
  INamedDocument,
  ISODateType,
  ISoftDelete,
  Timestamp,
} from '@principle-theorem/shared';
import { IStaffer } from '../staffer/staffer';
import { MixedSchema } from '@principle-theorem/editor';

export enum PracticeSetupStepId {
  // General Practice Settings
  PracticeInfo = 'practiceInfo',
  RoleSettings = 'roleSettings',
  StaffSetup = 'staffSetup',
  ProviderNumbers = 'providerNumbers',
  RosterSetup = 'rosterSetup',
  RosterBreaks = 'rosterBreaks',
  TeamsSetup = 'teamsSetup',

  // Fees & Accounting
  TransactionTypes = 'transactionTypes',
  FeeSchedule = 'feeSchedule',

  // Conditions & Treatments
  TreatmentCategories = 'treatmentCategories',
  ConditionsSetup = 'conditionsSetup',
  TreatmentsSetup = 'treatmentsSetup',
  MultiTreatmentsSetup = 'multiTreatmentsSetup',
  TreatmentTemplatesSetup = 'treatmentTemplatesSetup',

  // Miscellaneous
  ReferralSources = 'referralSources',
  ExternalContacts = 'externalContacts',
  TagsSetup = 'tagsSetup',
  MedicalHistoryAlerts = 'medicalHistoryAlerts',
  SterilisationTracking = 'sterilisationTracking',

  // Additional Settings
  GeneralSettings = 'generalSettings',
  AppointmentAutomations = 'appointmentAutomations',
  TreatmentAutomations = 'treatmentAutomations',
  ProductsForSale = 'productsForSale',
  CustomForms = 'customForms',
  Snippets = 'snippets',
  Labs = 'labs',
  DocumentTemplates = 'documentTemplates',
  PrescriptionsSetup = 'prescriptionsSetup',
  AccMohSetup = 'accMohSetup',

  // Uncategorised
  CalendarEvents = 'calendarEvents',
  TaskSetup = 'taskSetup',
}

export enum PracticeSetupStepCategory {
  GeneralPracticeSettings = 'generalPracticeSettings',
  ConditionsAndTreatments = 'conditionsAndTreatments',
  FeesAndAccounting = 'feesAndAccounting',
  Miscellaneous = 'miscellaneous',
  AdditionalSettings = 'additionalSettings',
}

export enum PracticeSetupStepStatus {
  NotStarted = 'notStarted',
  InProgress = 'inProgress',
  ValidationFailed = 'validationFailed',
  Complete = 'complete',
}

export const PRACTICE_SETUP_STEP_STATUS_COLOUR_MAP: {
  [key in PracticeSetupStepStatus]: string;
} = {
  [PracticeSetupStepStatus.NotStarted]: 'default',
  [PracticeSetupStepStatus.InProgress]: 'primary',
  [PracticeSetupStepStatus.ValidationFailed]: 'warn',
  [PracticeSetupStepStatus.Complete]: 'success',
};

export interface IPracticeSetupStep extends ISoftDelete {
  id: PracticeSetupStepId;
  category: PracticeSetupStepCategory;
  title: string;
  description: MixedSchema;
  status: PracticeSetupStepStatus;
  assignedUser?: INamedDocument<IStaffer>;
  dueDate?: ISODateType;
  completedAt?: Timestamp;
  completedBy?: INamedDocument<IStaffer>;
  validationPassed: boolean;
  validationErrors?: string[];
  pageVisits?: IPageVisit[];
}

export interface IPageVisit {
  route: string;
  visitedAt: Timestamp;
  visitedBy: INamedDocument<IStaffer>;
}
